import { render } from "./ListPendingOrderProducts.vue?vue&type=template&id=46cf6aa5"
import script from "./ListPendingOrderProducts.vue?vue&type=script&lang=js"
export * from "./ListPendingOrderProducts.vue?vue&type=script&lang=js"

import "./ListPendingOrderProducts.vue?vue&type=style&index=0&id=46cf6aa5&lang=scss"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__